import { useState, useEffect } from 'react'
import { Box, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, CircularProgress, Typography } from '@mui/material';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBiocharMassBags, postBiocharMassBagMoistureContent } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { v4 as uuidv4 } from 'uuid';
import useTsPaginator from 'ts-paginator';
import { getTableTotalRecordCount } from '../../../../../actions/tigercat-burns/tigercat-base-actions';
import Paginator from '../../../../layout/Pagination';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const BiocharMassBags = ({ projectId, project }) => {
    const [biocharMassBagsState, setBiocharMassBagsState] = useState([])
    const dispatch = useDispatch()
    const tableRecordCount = useSelector(state => state.tigercatBurnsBaseReducer.totalRecordCount.count)
    const biocharMassBags = useSelector(state => state.tigercatBurnsReducer.biocharMassBags.data)
    const [loading, setLoading] = useState(false)
    const [currentProjectId, setCurrentProjectId] = useState(projectId);
    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        setCurrentProjectId(projectId);
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [projectId, currentProjectId, tableRecordCount]);

    useEffect(() => {
        dispatch(getTableTotalRecordCount('biochar_mass_bags', projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        if (!isNaN(currentPage) && !isNaN(rowsPerPage)) {
            dispatch(getBiocharMassBags(projectId, +rowsPerPage, +currentPage));
        }
    }, [dispatch, projectId, rowsPerPage, currentPage]);

    useEffect(() => {
        const formDataArray = biocharMassBags?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('date', item.created_at.split('T')[0]);
            formData.append('submittedAt', item.submittedAt);
            formData.append('user', item.user_name)
            formData.append('mbId', item.mbId);
            formData.append('bagCount', item.bagCount);
            formData.append('massOfBag', item.massOfBag);
            formData.append('moistureContent', item.moistureContent);
            formData.append('measurementPhoto', item.measurementPhoto);
            formData.append('dryMatter', item.dryMatter);
            formData.append('dryMass', item.dryMass);
            formData.append('dispatched', item.dispatched);
            formData.append('rowId', uuidv4())
            formData.append('disabled', item.moistureContent ? true : false);
            return formData;
        });
        setBiocharMassBagsState(formDataArray);
    }, [biocharMassBags, currentPage, rowsPerPage, projectId]);

    const handleSubmitData = () => {
        dispatch(postBiocharMassBagMoistureContent(biocharMassBagsState.map((i) => {
            return {
                id: i.get('id'),
                date: i.get('date'),
                user: i.get('user_name'),
                mbId: i.get('mbId'),
                massOfBag: i.get('massOfBag'),
                moistureContent: i.get('moistureContent'),
                measurementPhoto: i.get('measurementPhoto'),
                dryMass: i.get('dryMass'),
                disabled: i.get('disabled')
            }
        }), projectId)).then(() => {
            dispatch(getBiocharMassBags(projectId, +rowsPerPage, +currentPage));
            setLoading(false)
        })
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'biochar_mass_bags')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_biochar_mass_bags.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Biochar Mass Bins:', err);
        }
    };

    return (
        <>
            <h2>Biochar Mass - Bags</h2>
            <TableContainer key={0} component={Paper} >
                <Button variant='contained' size="small" sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
                <Table crow aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">
                                User
                            </TableCell>
                            <TableCell size="small" align="left">
                                Synced Date
                            </TableCell>
                            <TableCell size="small" align="left">
                                Submission Date
                            </TableCell>
                            <TableCell size="small" align="left">
                                <Box sx={{ display: 'flex' }}>
                                    Mb Id <ExpandLessIcon sx={{ cursor: 'pointer' }} />
                                </Box>
                            </TableCell>
                            <TableCell size="small" align="left">
                                Bag #
                            </TableCell>
                            <TableCell size="small" align="left">
                                Measurement (lbs)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Measurement Photo
                            </TableCell>
                            <TableCell size="small" align="left">
                                Moisture Content
                            </TableCell>
                            <TableCell size="small" align="left">
                                Dry Matter
                            </TableCell>
                            <TableCell size="small" align="left">
                                Dry Mass
                            </TableCell>
                            <TableCell size="small" align="left">
                                Location
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {biocharMassBagsState?.map((data, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell size="small" align="left">
                                        {data.get('user')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {moment(data.get('date')).format('MM-DD-YY')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.get('submittedAt') !== 'null' ? moment(data.get('submittedAt')).format('MM-DD-YY') : ''}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.get('mbId')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.get('bagCount')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.get('massOfBag')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {/* add null ternary */}
                                        {data.get('measurementPhoto') !== 'null' ? <a rel="noreferrer" href={data.get('measurementPhoto')} target="_blank">Photo</a> : ''}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {JSON.parse(data.get('moistureContent')) === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.get('moistureContent')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {JSON.parse(data.get('dryMatter')) === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.get('dryMatter')}
                                    </TableCell>
                                    {/* {console.log(JSON.parse(data.get('dispatched')))} */}
                                    <TableCell size="small" align="left">
                                        {JSON.parse(data.get('dryMass')) === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.get('dryMass')}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {JSON.parse(data.get('dispatched')) === false ? <Typography sx={{ color: 'darkorange' }}>{`${data.get('mbId').split('-')[1]}-${data.get('bagCount')} On-Site`}</Typography> : <Typography sx={{ color: 'darkgreen' }}>{`${data.get('mbId').split('-')[1]}-${data.get('bagCount')} Dispatched`}</Typography>}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Paginator
                totalRecordCount={totalRecordCount}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                handleChangePage={_handleChangePage}
                handleChangeRowsPerPage={_handleChangeRowsPerPage}
                determinePaginationMessage={_determinePaginationMessage}
                determinePaginationDisabledState={_determinePaginationDisabledState}
                determineRowsPerPageOptions={_determineRowsPerPageOptions}
            />
            <Box sx={{ position: 'relative', mb: 2 }}>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '0px', top: '12px' }}></CircularProgress> : <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleSubmitData}>Submit Data</Button>}
            </Box>
        </>
    )
}

export default BiocharMassBags